<template>
  <div :class="`award-img`" :style="{ backgroundImage }">
    <!-- <div class="award_name">
      红包
    </div>
    <div class="award_type">满88可用</div> -->
  </div>
</template>

<script>
export default {
  /**
   * @param {Number} type: 1、加油券 2、红包 3、其他红包
   */
  props: ['awardData'],
  computed: {
    awardClass() {
      return this.type == 1
        ? 'oil_coupon'
        : this.type == 2
        ? 'red_package'
        : 'other_package';
    },
    backgroundImage() {
      return this.awardData.imgUrl ? `url(${this.awardData.imgUrl})` : '';
    }
  }
};
</script>

<style lang="less" scoped>
.award-img {
  width: 140px;
  height: 140px;
  background: #fff no-repeat center center;
  background-size: cover;
  position: relative;
  color: #fff;
  &.oil_coupon {
    background-image: url('../../assets/images/my_award1.png');
  }
  &.red_package {
    background-image: url('../../assets/images/my_award2.png');
    .award_name {
      top: 68px;
    }
    .award_type {
      display: none;
    }
  }
  &.other_package {
    background-image: url('../../assets/images/my_award3.png');
  }
  > div {
    position: absolute;
    left: 0px;
    width: 100%;
    text-align: center;
    &.award_name {
      top: 36px;
      height: 36px;
      line-height: 36px;
      font-size: 36px;
    }
    &.award_type {
      bottom: 14px;
      font-size: 22px;
      height: 22px;
      line-height: 22px;
      transform: scale(0.85);
    }
  }
}
</style>
